import { Skeleton, Space } from 'antd';
import { selectors } from 'app/services/projects';
import { DataForm, FieldProps, FieldType } from 'components';
import { useSelector } from 'react-redux';
import { chartIds } from 'utils/chart';
import Chart from '../../Tabs/components/Chart';
import Pictures from '../../Tabs/Pictures';
import { Drawers } from 'app/types/drawer';
import { useTranslation } from 'react-i18next';
import { ProjectReportType } from 'constants/project';
import { supportedLanguages } from 'utils/i18n';
import { useReportLanguage } from 'hooks';

type NotesFormProps = {
  handleSubmit: (values: any) => void;
  meta: any;
  formId: string;
}

const NotesForm = ({ handleSubmit, meta, formId }: NotesFormProps) => {
  const data = useSelector(selectors.getProject);
  const { t } = useTranslation();
  const { lang, setLanguage, isReady } = useReportLanguage();

  const fields: FieldProps[] = [
    { name: 'QuantitiesComments', type: FieldType.TEXTAREA, group: 2, max: 1024 },
    { name: 'CloseNotes', type: FieldType.TEXTAREA, group: 2, max: 1024 },
    { name: 'OtherComments', type: FieldType.TEXTAREA, group: 3, max: 1024 },
    { name: 'SafetyComments', type: FieldType.TEXTAREA, group: 3, max: 1024 }
  ];

  if (formId === Drawers.ADD_NOTES) {

    const reportTypeField: FieldProps = {
      name: 'ReportType',
      required: true,
      type: FieldType.SELECT,
      selectProps: {
        options: [
          { label: t('entities.project.reports.asbestos'), value: ProjectReportType.ASBESTOS },
          { label: t('entities.project.reports.measurement'), value: ProjectReportType.MEASUREMENT },
          { label: t('entities.project.reports.negativepressure'), value: ProjectReportType.NEGATIVE_PRESSURE }
        ],
        valueKey: 'value',
        labelKey: 'label',
        allowClear: false,
        allowMaxWidth: true
      },
      group: 1,
    };

    const languageSelectionField: FieldProps = {
      name: 'ReportLanguage',
      required: true,
      type: FieldType.SELECT,
      selectProps:{
        options: [
          { label: t('common.languages.finnish'), value: supportedLanguages.FI.abrevation },
          { label: t('common.languages.english'), value: supportedLanguages.EN.abrevation }
        ],
        valueKey: 'value',
        labelKey: 'label',
        allowMaxWidth: true
      },
      onChange: (value: string) => setLanguage(value),
      group: 1
    };

    fields.unshift(reportTypeField, languageSelectionField);
  }

  if (!data || !isReady) return <Skeleton active />;

  return (
    <Space direction='vertical' size={'middle'} style={{ display: 'flex' }}>
      <Chart id={chartIds.PROJECT_MEASUREMENTS_DRAWER} />
      <Pictures readonly />
      <DataForm
        id={formId}
        entity="project"
        onSubmit={handleSubmit}
        fields={fields}
        meta={meta}
        initialValues={{ ...data, ReportLanguage: lang }}
      />
    </Space>
  );
};

export default NotesForm;